import { render } from "./HelloWorld.vue?vue&type=template&id=616599d0"
const script = {}
script.render = render

export default script